<template>
    <div class="my-google-map" ref="myMap">
        <slot></slot>
    </div>
</template>
<script>
    export default {
        mounted() {
            $(this.$refs.myMap).click(function () {
                $(this).find('iframe').addClass('clicked');
            })
            .mouseleave(function () {
                $(this).find('iframe').removeClass('clicked');
            });
        },
        methods: {

        }
    }
</script>